import { Colors } from '@/common/colors/colors';

export const getMessageBackgroundColor = (message, userId) =>
	(message.sender || message.created_by) === userId
		? Colors.lightBlue2
		: Colors.lightGray;
